/* eslint-disable no-unused-expressions */
/* eslint-disable arrow-parens */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react'
import clsx from 'clsx'
import s from './SimpleSlider.module.css'

const SimpleSwiper = forwardRef(
  ({ children, slidesPerView = 1, spaceBetween = 0, pagination = false, className = '', onChangeIndex }, ref) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isDragging, setIsDragging] = useState(false)
    const [startX, setStartX] = useState(0)
    const [translateX, setTranslateX] = useState(0)
    const containerRef = useRef(null)

    const slides = React.Children.toArray(children)
    const totalSlides = slides.length
    const maxIndex = Math.max(0, Math.ceil(totalSlides / slidesPerView) - 1)

    useEffect(() => {
      onChangeIndex?.(currentIndex)
    }, [currentIndex, onChangeIndex])

    useImperativeHandle(ref, () => ({
      slideNext: () => {
        setCurrentIndex((prev) => Math.min(prev + 1, maxIndex))
      },
      slidePrev: () => {
        setCurrentIndex((prev) => Math.max(prev - 1, 0))
      },
      slideTo: (index) => {
        setCurrentIndex(Math.max(0, Math.min(index, maxIndex)))
      },
      getCurrentIndex: () => currentIndex,
    }))

    const handleTouchStart = (e) => {
      setIsDragging(true)
      setStartX(e.touches[0].clientX)
    }

    const handleTouchMove = (e) => {
      if (!isDragging) return

      const currentX = e.touches[0].clientX
      const diff = startX - currentX
      setTranslateX(-diff)
    }

    const handleTouchEnd = () => {
      if (!isDragging) return

      setIsDragging(false)

      const threshold = 30

      if (Math.abs(translateX) > threshold) {
        if (translateX < 0 && currentIndex < maxIndex) {
          setCurrentIndex((prev) => prev + 1)
        } else if (translateX > 0 && currentIndex > 0) {
          setCurrentIndex((prev) => prev - 1)
        }
      }

      setTranslateX(0)
    }

    const handleMouseDown = (e) => {
      setIsDragging(true)
      setStartX(e.clientX)
    }

    const handleMouseMove = (e) => {
      if (!isDragging) return

      const currentX = e.clientX
      const diff = startX - currentX
      setTranslateX(-diff)
    }

    const handleMouseUp = () => {
      if (!isDragging) return

      setIsDragging(false)

      const threshold = 50

      if (Math.abs(translateX) > threshold) {
        if (translateX > 0 && currentIndex < maxIndex) {
          setCurrentIndex((prev) => prev + 1)
        } else if (translateX < 0 && currentIndex > 0) {
          setCurrentIndex((prev) => prev - 1)
        }
      }

      setTranslateX(0)
    }

    const containerWidthPercent = (totalSlides / slidesPerView) * 100
    const slideWidthInContainer = 100 / totalSlides

    const translatePercent = currentIndex * slidesPerView * slideWidthInContainer

    const finalTranslateX = isDragging
      ? -translatePercent + (translateX / containerRef.current?.offsetWidth) * 100
      : -translatePercent

    const slidesGap = slidesPerView > 1 ? (spaceBetween * (totalSlides - 1)) / totalSlides : 0
    const transalteGap = slidesPerView > 1 ? 0 : currentIndex * spaceBetween

    return (
      <div className={clsx(s.simpleSwiper, className)}>
        <div
          ref={containerRef}
          className={s.simpleSwiperWrapper}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          style={{
            transform: `translateX(calc(${finalTranslateX}% - ${transalteGap}px))`,
            transition: isDragging ? 'none' : 'transform 0.3s ease',
            display: 'flex',
            width: `${containerWidthPercent}%`,
            cursor: isDragging ? 'grabbing' : 'grab',
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className={s.simpleSwiperSlide}
              style={{
                width: `calc(${slideWidthInContainer}% - ${slidesGap}px)`,
                marginRight: index < slides.length - 1 ? `${spaceBetween}px` : '0',
                flexShrink: 0,
              }}
            >
              {slide}
            </div>
          ))}
        </div>

        {pagination && (
          <div className={s.simpleSwiperPagination}>
            {Array.from({ length: maxIndex + 1 }, (_, index) => (
              <button
                key={index}
                className={clsx(s.simpleSwiperPaginationDot, index === currentIndex && s.active)}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
)

const SwiperSlide = ({ children, className = '' }) => (
  <div className={clsx(s.simpleSwiperSlide, className)}>{children}</div>
)

export { SimpleSwiper, SwiperSlide }
